import React, { useEffect } from 'react';
import '../fulfillmentTiles.scss';
import { setErrorEvents } from '../../../analytics';

export const BackorderedAlert = () => {
  useEffect(() => {
    setErrorEvents({ message: 'This product is currently backordered. We won\'t charge you until it ships.' });
  }, []);

  return (
    <div className="alert-inline alert-inline--warning inventory--warning-tiles">
      <div>
        <span>This product is currently</span>
        <span className="u__bold">&nbsp;backordered.&nbsp;</span>
        <span>{'We won\'t charge you until it ships.'}</span>
      </div>
    </div>
  );
};